import { api_GET } from "api/axios.js";

const setup_api =
{
    getSetup: function(){
        const promise = new Promise((resolve, reject) => { 
            api_GET('SetupDashboard/GetSetupDashboard').then(result => {
                resolve(result)
            });
        });

        return promise;
    },
}

export default setup_api